import { useState, useRef } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

import edit from "../../edit.png";
import trash from "../../trash.png";
import icoArrow from '../../Down_Arrow_3_.png'

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputDate from "../../helpers/InputDate";
import AppContext from "../../AppContext";

 








function Arch(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({

        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''),

        data_od: '',
        data_do: '',

        fraza: '', 
        limit: 50,
        page: 1,
        pages: 1,
        show: false,
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0); //do druku


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,arch', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
       // if(filterParam[filedName] != val && val.length == 0)
        //setTab(null);  

       if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }



    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', '');

        setFilterParam({
            fraza: '',         
            d_imie_nazwisko: '',         

            data_od: '',
            data_do: '',

            limit: 50,
            page: 1,
            show: true,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
    }





    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = () => {
       
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        getTab();
    }



 
 
    

    return (

        <div className="view_content">


            <div className="tip">
               System każdej nocy, po zakończeniu dnia zbiera podstawowe informacje o dziecku i zapisuje je do archiwum. 
            </div>

            <br/>
         
            <div className="tip">
                Możesz tutaj sprawdzić min. in. do jakiej grupy należało dziecko wybranego dnia, czy było obecne, ile spędziło godzin w placówce, itd.
            </div>

            <br/>

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 



                {
                    filterParam.show == true  &&
                    <div className="table_filter">
               
                            <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  

                            <div className="filter_controll filter_merge">   
                                <label>Dzień (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                          </div>

                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                    </div>
                }      

          



            <div className="bg_center">


                    <div className="table_widget">                       
                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                    </div>
 

                    <div className="scorll_x">
                            <table className="table" ref={tabRef}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Dzień</td>                               
                                                <td>Rok szkolny</td>                                                                                                                                                                                                                
                                                <td>Nazwa grupy</td>                                                                                                                                                                                                                
                                                <td>Dziecko</td>                                                                                                                                                                                                                
                                                <td>Status</td>                                                                                                                                                                                                                
                                                <td>Czas w placówce</td>                                                                                                                                                                                                                
                                                <td>Godziny płatne</td>                                                                                                                                                                                                                
                                                <td>Nadgodziny płatne</td>                                                                                                                                                                                                                
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="gocenter">{row.dzien}</td>
                                                            <td className="gocenter">{row.rok_szkolny}</td>                                                                                                                                                                             
                                                            <td className="goleft">{row.arch_nazwa_grupy}</td>                                                                                                                                                                             
                                                            <td className="goleft">{row.arch_nazwisko + " " + row.arch_imie}</td>                                                                                                                                                                             
                                                            <td className="goleft">{row.status}</td>                                                                                                                                                                             
                                                            <td className="gocenter">{row.minuty_w_szkole}</td>                                                                                                                                                                             
                                                            <td className="gocenter">{row.godziny_platne_min}</td>                                                                                                                                                                             
                                                            <td className="gocenter">{row.nadgodziny_platne_min}</td>                                                                                                                                                                             
                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
                    </div>
            </div>


        </div>

    )

}

export default Arch;